import { faker } from '@faker-js/faker';
import { useDailyReportHeaderSectionQuery } from 'generated/graphql';
import _ from 'lodash';
import { DateTime } from 'luxon';
import { DashMetricTypes } from 'modules/components/layer05/DashboardMetric/DashboardMetric';
import React from 'react';

type DashboardMetricDataType = {
  id: string;
  metricType: DashMetricTypes;
  count: number;
  title: string;
};

type IWeatherData = {
  id: string;
  condition: string;
  maxTemp: number;
  minTemp: number;
  precipitationAmount: number;
};

export interface IData {
  inspections: DashboardMetricDataType;
  accidents: DashboardMetricDataType;
  addressFull: string;
  name: string;
  reportDate: DateTime | null;
  nextReportId: string;
  todayReportId: string;
  previousReportId: string;
  id: string;
  isApproved: boolean;
  weather: IWeatherData;
}

export function useQuery(projectId: string, id: string) {
  const tuple = useDailyReportHeaderSectionQuery({
    variables: {
      options: {
        filter: {
          projectId
        }
      }
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const sortedReports = _.sortBy(tuple.data?.dailyReports, (node) => node.reportDate.toMillis());
      const reportIndex = sortedReports.findIndex((node) => node.id === id);
      const report = sortedReports[reportIndex];
      const nextReportId = sortedReports[reportIndex + 1]?.id ?? report?.id;
      const previousReportId = sortedReports[reportIndex - 1]?.id ?? report?.id;
      const todayReportId = sortedReports.find((node) => node?.reportDate === DateTime.fromISO(DateTime.now().toISODate()))?.id ?? '';

      const data: IData = {
        id: report?.id ?? '',
        inspections: __genDashboardMetric('inspections', report?.numberOfInspections ?? 0),
        accidents: __genDashboardMetric('accidents', report?.numberOfIncidents ?? 0),
        addressFull: report?.project.locationAddress.formattedFullAddress ?? '',
        name: report?.project.name ?? '',
        reportDate: report?.reportDate ?? null,
        todayReportId,
        nextReportId: nextReportId,
        previousReportId: previousReportId,
        isApproved: report?.approvedAt ? true : false,
        weather: {
          id: report?.weather.id ?? '',
          condition: report?.weather.condition.displayName ?? '',
          maxTemp: report?.weather.temperatureMax ?? 0,
          minTemp: report?.weather.temperatureMin ?? 0,
          precipitationAmount: report?.weather.precipitationAmount ?? 0
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [
      id,
      tuple
    ]
  );
}
function __genDashboardMetric(metricType: DashMetricTypes, count: number): DashboardMetricDataType {
  return {
    id: faker.string.uuid(),
    metricType: metricType,
    count: count,
    title: metricType
  };
}

